"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.JP = void 0;
exports.JP = {
    numericCode: '392',
    alpha2Code: 'JP',
    alpha3Code: 'JPN',
    englishName: {
        short: 'Japan',
        full: 'Japan',
    },
    names: {
        full: {
            en: 'Japan',
            fr: 'Japon (le)',
            ja: 'Nihon/Nippon',
        },
        short: {
            en: 'Japan',
            fr: 'Japon (le)',
            ja: 'Nihon/Nippon',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'ja',
            languageAlpha3Code: 'jpn',
            isAdministrative: true,
        },
    ],
    subdivisions: {
        'JP-01': {
            numericCode: '392',
            code: 'JP-01',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Hokkaido',
                ja: 'Hokkaidô',
            },
        },
        'JP-02': {
            numericCode: '392',
            code: 'JP-02',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ja: 'Aomori',
            },
        },
        'JP-03': {
            numericCode: '392',
            code: 'JP-03',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ja: 'Iwate',
            },
        },
        'JP-04': {
            numericCode: '392',
            code: 'JP-04',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ja: 'Miyagi',
            },
        },
        'JP-05': {
            numericCode: '392',
            code: 'JP-05',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ja: 'Akita',
            },
        },
        'JP-06': {
            numericCode: '392',
            code: 'JP-06',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ja: 'Yamagata',
            },
        },
        'JP-07': {
            numericCode: '392',
            code: 'JP-07',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Fukushima',
                ja: 'Hukusima',
            },
        },
        'JP-08': {
            numericCode: '392',
            code: 'JP-08',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ja: 'Ibaraki',
            },
        },
        'JP-09': {
            numericCode: '392',
            code: 'JP-09',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Tochigi',
                ja: 'Totigi',
            },
        },
        'JP-10': {
            numericCode: '392',
            code: 'JP-10',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ja: 'Gunma',
            },
        },
        'JP-11': {
            numericCode: '392',
            code: 'JP-11',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ja: 'Saitama',
            },
        },
        'JP-12': {
            numericCode: '392',
            code: 'JP-12',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Chiba',
                ja: 'Tiba',
            },
        },
        'JP-13': {
            numericCode: '392',
            code: 'JP-13',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Tokyo',
                ja: 'Tôkyô',
            },
        },
        'JP-14': {
            numericCode: '392',
            code: 'JP-14',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ja: 'Kanagawa',
            },
        },
        'JP-15': {
            numericCode: '392',
            code: 'JP-15',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ja: 'Niigata',
            },
        },
        'JP-16': {
            numericCode: '392',
            code: 'JP-16',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ja: 'Toyama',
            },
        },
        'JP-17': {
            numericCode: '392',
            code: 'JP-17',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Ishikawa',
                ja: 'Isikawa',
            },
        },
        'JP-18': {
            numericCode: '392',
            code: 'JP-18',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Fukui',
                ja: 'Hukui',
            },
        },
        'JP-19': {
            numericCode: '392',
            code: 'JP-19',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Yamanashi',
                ja: 'Yamanasi',
            },
        },
        'JP-20': {
            numericCode: '392',
            code: 'JP-20',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ja: 'Nagano',
            },
        },
        'JP-21': {
            numericCode: '392',
            code: 'JP-21',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Gifu',
                ja: 'Gihu',
            },
        },
        'JP-22': {
            numericCode: '392',
            code: 'JP-22',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Shizuoka',
                ja: 'Sizuoka',
            },
        },
        'JP-23': {
            numericCode: '392',
            code: 'JP-23',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Aichi',
                ja: 'Aiti',
            },
        },
        'JP-24': {
            numericCode: '392',
            code: 'JP-24',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ja: 'Mie',
            },
        },
        'JP-25': {
            numericCode: '392',
            code: 'JP-25',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Shiga',
                ja: 'Siga',
            },
        },
        'JP-26': {
            numericCode: '392',
            code: 'JP-26',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Kyoto',
                ja: 'Kyôto',
            },
        },
        'JP-27': {
            numericCode: '392',
            code: 'JP-27',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Osaka',
                ja: 'Ôsaka',
            },
        },
        'JP-28': {
            numericCode: '392',
            code: 'JP-28',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Hyogo',
                ja: 'Hyôgo',
            },
        },
        'JP-29': {
            numericCode: '392',
            code: 'JP-29',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ja: 'Nara',
            },
        },
        'JP-30': {
            numericCode: '392',
            code: 'JP-30',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ja: 'Wakayama',
            },
        },
        'JP-31': {
            numericCode: '392',
            code: 'JP-31',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ja: 'Tottori',
            },
        },
        'JP-32': {
            numericCode: '392',
            code: 'JP-32',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Shimane',
                ja: 'Simane',
            },
        },
        'JP-33': {
            numericCode: '392',
            code: 'JP-33',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ja: 'Okayama',
            },
        },
        'JP-34': {
            numericCode: '392',
            code: 'JP-34',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Hiroshima',
                ja: 'Hirosima',
            },
        },
        'JP-35': {
            numericCode: '392',
            code: 'JP-35',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Yamaguchi',
                ja: 'Yamaguti',
            },
        },
        'JP-36': {
            numericCode: '392',
            code: 'JP-36',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Tokushima',
                ja: 'Tokusima',
            },
        },
        'JP-37': {
            numericCode: '392',
            code: 'JP-37',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ja: 'Kagawa',
            },
        },
        'JP-38': {
            numericCode: '392',
            code: 'JP-38',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ja: 'Ehime',
            },
        },
        'JP-39': {
            numericCode: '392',
            code: 'JP-39',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Kochi',
                ja: 'Kôti',
            },
        },
        'JP-40': {
            numericCode: '392',
            code: 'JP-40',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Fukuoka',
                ja: 'Hukuoka',
            },
        },
        'JP-41': {
            numericCode: '392',
            code: 'JP-41',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ja: 'Saga',
            },
        },
        'JP-42': {
            numericCode: '392',
            code: 'JP-42',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ja: 'Nagasaki',
            },
        },
        'JP-43': {
            numericCode: '392',
            code: 'JP-43',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ja: 'Kumamoto',
            },
        },
        'JP-44': {
            numericCode: '392',
            code: 'JP-44',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Oita',
                ja: 'Ôita',
            },
        },
        'JP-45': {
            numericCode: '392',
            code: 'JP-45',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ja: 'Miyazaki',
            },
        },
        'JP-46': {
            numericCode: '392',
            code: 'JP-46',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Kagoshima',
                ja: 'Kagosima',
            },
        },
        'JP-47': {
            numericCode: '392',
            code: 'JP-47',
            category: {
                id: '247',
                names: {
                    en: {
                        singular: 'prefecture',
                        plural: 'prefectures',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ja: {
                        singular: 'to, dô, hu, ken',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ja: 'Okinawa',
            },
        },
    },
    cities: [
        {
            name: 'Shingū',
            subdivision: 'Wakayama',
        },
        {
            name: 'Atsugi',
            subdivision: 'Kanagawa',
        },
        {
            name: 'Akashi',
            subdivision: 'Hyōgo',
        },
        {
            name: 'Zushi',
            subdivision: 'Kanagawa',
        },
        {
            name: 'Zama',
            subdivision: 'Kanagawa',
        },
        {
            name: 'Yuza',
            subdivision: 'Yamagata',
        },
        {
            name: 'Gero',
            subdivision: 'Gifu',
        },
        {
            name: 'Yukuhashi',
            subdivision: 'Fukuoka',
        },
        {
            name: 'Yūki',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Yugawara',
            subdivision: 'Kanagawa',
        },
        {
            name: 'Yoshikawa',
            subdivision: 'Saitama',
        },
        {
            name: 'Yoshii',
            subdivision: 'Gunma',
        },
        {
            name: 'Yoshida-kasugachō',
            subdivision: 'Niigata',
        },
        {
            name: 'Yorii',
            subdivision: 'Saitama',
        },
        {
            name: 'Yono',
            subdivision: 'Saitama',
        },
        {
            name: 'Yonago',
            subdivision: 'Tottori',
        },
        {
            name: 'Yokosuka',
            subdivision: 'Kanagawa',
        },
        {
            name: 'Yokohama',
            subdivision: 'Kanagawa',
        },
        {
            name: 'Yokkaichi',
            subdivision: 'Mie',
        },
        {
            name: 'Youkaichi',
            subdivision: 'Shiga Prefecture',
        },
        {
            name: 'Yawata',
            subdivision: 'Kyoto',
        },
        {
            name: 'Yatsushiro',
            subdivision: 'Kumamoto',
        },
        {
            name: 'Yatsuomachi-higashikumisaka',
            subdivision: 'Toyama',
        },
        {
            name: 'Yasugichō',
            subdivision: 'Shimane',
        },
        {
            name: 'Yashiro',
            subdivision: 'Hyōgo',
        },
        {
            name: 'Yashio-shi',
            subdivision: 'Saitama',
        },
        {
            name: 'Yao',
            subdivision: 'Ōsaka',
        },
        {
            name: 'Yanai',
            subdivision: 'Yamaguchi',
        },
        {
            name: 'Yanagawa',
            subdivision: 'Fukuoka',
        },
        {
            name: 'Yamazakichō-nakabirose',
            subdivision: 'Hyōgo',
        },
        {
            name: 'Yamaguchi',
            subdivision: 'Yamaguchi',
        },
        {
            name: 'Yamaga',
            subdivision: 'Kumamoto',
        },
        {
            name: 'Yaizu',
            subdivision: 'Shizuoka',
        },
        {
            name: 'Yaita',
            subdivision: 'Tochigi',
        },
        {
            name: 'Wakimachi',
            subdivision: 'Tokushima',
        },
        {
            name: 'Utsunomiya',
            subdivision: 'Tochigi',
        },
        {
            name: 'Uto',
            subdivision: 'Kumamoto',
        },
        {
            name: 'Usuki',
            subdivision: 'Oita',
        },
        {
            name: 'Ushibuka',
            subdivision: 'Kumamoto',
        },
        {
            name: 'Ureshinomachi-shimojuku',
            subdivision: 'Saga Prefecture',
        },
        {
            name: 'Urayasu',
            subdivision: 'Tokyo',
        },
        {
            name: 'Uozu',
            subdivision: 'Toyama',
        },
        {
            name: 'Umi',
            subdivision: 'Fukuoka',
        },
        {
            name: 'Ujiie',
            subdivision: 'Tochigi',
        },
        {
            name: 'Uji',
            subdivision: 'Kyoto',
        },
        {
            name: 'Uenohara',
            subdivision: 'Yamanashi',
        },
        {
            name: 'Ueno-ebisumachi',
            subdivision: 'Mie',
        },
        {
            name: 'Ueki',
            subdivision: 'Kumamoto',
        },
        {
            name: 'Ueda',
            subdivision: 'Nagano',
        },
        {
            name: 'Ube',
            subdivision: 'Yamaguchi',
        },
        {
            name: 'Tsuyama',
            subdivision: 'Okayama',
        },
        {
            name: 'Tsushima',
            subdivision: 'Aichi',
        },
        {
            name: 'Tsurusaki',
            subdivision: 'Oita',
        },
        {
            name: 'Tsuruoka',
            subdivision: 'Yamagata',
        },
        {
            name: 'Tsurugi-asahimachi',
            subdivision: 'Ishikawa',
        },
        {
            name: 'Tsuruga',
            subdivision: 'Fukui',
        },
        {
            name: 'Tsuma',
            subdivision: 'Miyazaki',
        },
        {
            name: 'Tsukumiura',
            subdivision: 'Oita',
        },
        {
            name: 'Tsukawaki',
            subdivision: 'Oita',
        },
        {
            name: 'Tsubata',
            subdivision: 'Ishikawa',
        },
        {
            name: 'Tsubame',
            subdivision: 'Niigata',
        },
        {
            name: 'Tsu',
            subdivision: 'Mie',
        },
        {
            name: 'Toyota',
            subdivision: 'Aichi',
        },
        {
            name: 'Toyoshina',
            subdivision: 'Nagano',
        },
        {
            name: 'Toyooka',
            subdivision: 'Hyōgo',
        },
        {
            name: 'Toyonaka',
            subdivision: 'Ōsaka',
        },
        {
            name: 'Toyokawa',
            subdivision: 'Aichi',
        },
        {
            name: 'Toyohashi',
            subdivision: 'Aichi',
        },
        {
            name: 'Toyohama',
            subdivision: 'Aichi',
        },
        {
            name: 'Toyama',
            subdivision: 'Toyama',
        },
        {
            name: 'Tottori',
            subdivision: 'Tottori',
        },
        {
            name: 'Tosu',
            subdivision: 'Saga Prefecture',
        },
        {
            name: 'Tonoshō',
            subdivision: 'Kagawa',
        },
        {
            name: 'Tondabayashichō',
            subdivision: 'Ōsaka',
        },
        {
            name: 'Tomioka',
            subdivision: 'Gunma',
        },
        {
            name: 'Tomigusuku',
            subdivision: 'Okinawa',
        },
        {
            name: 'Tokyo',
            subdivision: 'Tokyo',
        },
        {
            name: 'Tokuyama',
            subdivision: 'Yamaguchi',
        },
        {
            name: 'Tokushima',
            subdivision: 'Tokushima',
        },
        {
            name: 'Tokorozawa',
            subdivision: 'Saitama',
        },
        {
            name: 'Tokoname',
            subdivision: 'Aichi',
        },
        {
            name: 'Toki',
            subdivision: 'Gifu',
        },
        {
            name: 'Tōkamachi',
            subdivision: 'Niigata',
        },
        {
            name: 'Togitsu',
            subdivision: 'Nagasaki',
        },
        {
            name: 'Tochio-honchō',
            subdivision: 'Niigata',
        },
        {
            name: 'Tochigi',
            subdivision: 'Tochigi',
        },
        {
            name: 'Toba',
            subdivision: 'Mie',
        },
        {
            name: 'Tenri',
            subdivision: 'Nara',
        },
        {
            name: 'Tennō',
            subdivision: 'Akita',
        },
        {
            name: 'Tawaramoto',
            subdivision: 'Nara',
        },
        {
            name: 'Tatsuno',
            subdivision: 'Nagano',
        },
        {
            name: 'Tatsunochō-tominaga',
            subdivision: 'Hyōgo',
        },
        {
            name: 'Tateyama',
            subdivision: 'Chiba',
        },
        {
            name: 'Tatebayashi',
            subdivision: 'Gunma',
        },
        {
            name: 'Tarumizu',
            subdivision: 'Kagoshima',
        },
        {
            name: 'Tarui',
            subdivision: 'Gifu',
        },
        {
            name: 'Tanushimarumachi-toyoki',
            subdivision: 'Fukuoka',
        },
        {
            name: 'Tanuma',
            subdivision: 'Tochigi',
        },
        {
            name: 'Nishi-Tokyo-shi',
            subdivision: 'Tokyo',
        },
        {
            name: 'Tanashichō',
            subdivision: 'Tokyo',
        },
        {
            name: 'Tanabe',
            subdivision: 'Kyoto',
        },
        {
            name: 'Tanabe',
            subdivision: 'Wakayama',
        },
        {
            name: 'Tamano',
            subdivision: 'Okayama',
        },
        {
            name: 'Tamana',
            subdivision: 'Kumamoto',
        },
        {
            name: 'Tamamura',
            subdivision: 'Gunma',
        },
        {
            name: 'Taketoyo',
            subdivision: 'Aichi',
        },
        {
            name: 'Takeochō-takeo',
            subdivision: 'Saga Prefecture',
        },
        {
            name: 'Takehara',
            subdivision: 'Hiroshima',
        },
        {
            name: 'Takefu',
            subdivision: 'Fukui',
        },
        {
            name: 'Takedamachi',
            subdivision: 'Oita',
        },
        {
            name: 'Takayama',
            subdivision: 'Gifu',
        },
        {
            name: 'Takatsuki',
            subdivision: 'Ōsaka',
        },
        {
            name: 'Takasaki',
            subdivision: 'Gunma',
        },
        {
            name: 'Takarazuka',
            subdivision: 'Hyōgo',
        },
        {
            name: 'Takaoka',
            subdivision: 'Toyama',
        },
        {
            name: 'Takanabe',
            subdivision: 'Miyazaki',
        },
        {
            name: 'Takamatsu',
            subdivision: 'Kagawa',
        },
        {
            name: 'Takaishi',
            subdivision: 'Ōsaka',
        },
        {
            name: 'Takahashi',
            subdivision: 'Okayama',
        },
        {
            name: 'Takahama',
            subdivision: 'Aichi',
        },
        {
            name: 'Bungo-Takada-shi',
            subdivision: 'Oita',
        },
        {
            name: 'Tajimi',
            subdivision: 'Gifu',
        },
        {
            name: 'Tahara',
            subdivision: 'Aichi',
        },
        {
            name: 'Tagawa',
            subdivision: 'Fukuoka',
        },
        {
            name: 'Tadotsu',
            subdivision: 'Kagawa',
        },
        {
            name: 'Suzuka',
            subdivision: 'Mie',
        },
        {
            name: 'Suzaka',
            subdivision: 'Nagano',
        },
        {
            name: 'Suwa',
            subdivision: 'Nagano',
        },
        {
            name: 'Susaki',
            subdivision: 'Kochi',
        },
        {
            name: 'Sumoto',
            subdivision: 'Hyōgo',
        },
        {
            name: 'Sukumo',
            subdivision: 'Kochi',
        },
        {
            name: 'Suita',
            subdivision: 'Ōsaka',
        },
        {
            name: 'Suibara',
            subdivision: 'Niigata',
        },
        {
            name: 'Sugito',
            subdivision: 'Saitama',
        },
        {
            name: 'Sueyoshichō-ninokata',
            subdivision: 'Kagoshima',
        },
        {
            name: 'Sōka',
            subdivision: 'Saitama',
        },
        {
            name: 'Sōja',
            subdivision: 'Okayama',
        },
        {
            name: 'Sobue',
            subdivision: 'Aichi',
        },
        {
            name: 'Shōbu',
            subdivision: 'Saitama',
        },
        {
            name: 'Shōbara',
            subdivision: 'Hiroshima',
        },
        {
            name: 'Shizuoka',
            subdivision: 'Shizuoka',
        },
        {
            name: 'Shirone',
            subdivision: 'Niigata',
        },
        {
            name: 'Shiraoka',
            subdivision: 'Saitama',
        },
        {
            name: 'Shirahamachō-usazakiminami',
            subdivision: 'Hyōgo',
        },
        {
            name: 'Shiozawa',
            subdivision: 'Niigata',
        },
        {
            name: 'Shiojiri',
            subdivision: 'Nagano',
        },
        {
            name: 'Shinshiro',
            subdivision: 'Aichi',
        },
        {
            name: 'Shin’ichi',
            subdivision: 'Hiroshima',
        },
        {
            name: 'Shingū',
            subdivision: 'Fukuoka',
        },
        {
            name: 'Shimonoseki',
            subdivision: 'Yamaguchi',
        },
        {
            name: 'Shimodate',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Shimoda',
            subdivision: 'Shizuoka',
        },
        {
            name: 'Minato',
            subdivision: 'Wakayama',
        },
        {
            name: 'Nishishinminato',
            subdivision: 'Toyama',
        },
        {
            name: 'Shimada',
            subdivision: 'Shizuoka',
        },
        {
            name: 'Shimabara',
            subdivision: 'Nagasaki',
        },
        {
            name: 'Shiki',
            subdivision: 'Saitama',
        },
        {
            name: 'Shido',
            subdivision: 'Kagawa',
        },
        {
            name: 'Shibushi',
            subdivision: 'Kagoshima',
        },
        {
            name: 'Shibukawa',
            subdivision: 'Gunma',
        },
        {
            name: 'Shibata',
            subdivision: 'Niigata',
        },
        {
            name: 'Seto',
            subdivision: 'Aichi',
        },
        {
            name: 'Setakamachi-takayanagi',
            subdivision: 'Fukuoka',
        },
        {
            name: 'Satsumasendai',
            subdivision: 'Kagoshima',
        },
        {
            name: 'Satte',
            subdivision: 'Saitama',
        },
        {
            name: 'Sasebo',
            subdivision: 'Nagasaki',
        },
        {
            name: 'Sasayama',
            subdivision: 'Hyōgo',
        },
        {
            name: 'Sasaguri',
            subdivision: 'Fukuoka',
        },
        {
            name: 'Sano',
            subdivision: 'Tochigi',
        },
        {
            name: 'Sanjō',
            subdivision: 'Niigata',
        },
        {
            name: 'Sandachō',
            subdivision: 'Hyōgo',
        },
        {
            name: 'Sakurai',
            subdivision: 'Nara',
        },
        {
            name: 'Saku',
            subdivision: 'Nagano',
        },
        {
            name: 'Sakata',
            subdivision: 'Yamagata',
        },
        {
            name: 'Sakaiminato',
            subdivision: 'Shimane',
        },
        {
            name: 'Sakaidechō',
            subdivision: 'Kagawa',
        },
        {
            name: 'Sakai-nakajima',
            subdivision: 'Gunma',
        },
        {
            name: 'Sakai',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Sakai',
            subdivision: 'Ōsaka',
        },
        {
            name: 'Sakado',
            subdivision: 'Saitama',
        },
        {
            name: 'Saiki',
            subdivision: 'Oita',
        },
        {
            name: 'Sagara',
            subdivision: 'Shizuoka',
        },
        {
            name: 'Saga',
            subdivision: 'Saga Prefecture',
        },
        {
            name: 'Sabae',
            subdivision: 'Fukui',
        },
        {
            name: 'Ryūō',
            subdivision: 'Yamanashi',
        },
        {
            name: 'Ryōtsu-minato',
            subdivision: 'Niigata',
        },
        {
            name: 'Ōzu',
            subdivision: 'Kumamoto',
        },
        {
            name: 'Oyama',
            subdivision: 'Tochigi',
        },
        {
            name: 'Ōyama',
            subdivision: 'Shizuoka',
        },
        {
            name: 'Owase',
            subdivision: 'Mie',
        },
        {
            name: 'Ōtsuki',
            subdivision: 'Yamanashi',
        },
        {
            name: 'Ōtsu',
            subdivision: 'Shiga Prefecture',
        },
        {
            name: 'Ōtake',
            subdivision: 'Yamaguchi',
        },
        {
            name: 'Ōta',
            subdivision: 'Gunma',
        },
        {
            name: 'Osaka',
            subdivision: 'Ōsaka',
        },
        {
            name: 'Onomichi',
            subdivision: 'Hiroshima',
        },
        {
            name: 'Onoda',
            subdivision: 'Yamaguchi',
        },
        {
            name: 'Ono',
            subdivision: 'Fukui',
        },
        {
            name: 'Ono',
            subdivision: 'Hyōgo',
        },
        {
            name: 'Ōno-hara',
            subdivision: 'Hiroshima',
        },
        {
            name: 'Ōmuta',
            subdivision: 'Fukuoka',
        },
        {
            name: 'Ōmura',
            subdivision: 'Nagasaki',
        },
        {
            name: 'Ōme',
            subdivision: 'Tokyo',
        },
        {
            name: 'Ōmamachō-ōmama',
            subdivision: 'Gunma',
        },
        {
            name: 'Ōmachi',
            subdivision: 'Nagano',
        },
        {
            name: 'Ōkuchi-shinohara',
            subdivision: 'Kagoshima',
        },
        {
            name: 'Okegawa',
            subdivision: 'Saitama',
        },
        {
            name: 'Okazaki',
            subdivision: 'Aichi',
        },
        {
            name: 'Okayama',
            subdivision: 'Okayama',
        },
        {
            name: 'Okaya',
            subdivision: 'Nagano',
        },
        {
            name: 'Ōkawa',
            subdivision: 'Saga Prefecture',
        },
        {
            name: 'Ojiya',
            subdivision: 'Niigata',
        },
        {
            name: 'Ōita',
            subdivision: 'Oita',
        },
        {
            name: 'Ōiso',
            subdivision: 'Kanagawa',
        },
        {
            name: 'Ōi',
            subdivision: 'Saitama',
        },
        {
            name: 'Ogōri-shimogō',
            subdivision: 'Yamaguchi',
        },
        {
            name: 'Ogawa',
            subdivision: 'Saitama',
        },
        {
            name: 'Ōgaki',
            subdivision: 'Gifu',
        },
        {
            name: 'Odawara',
            subdivision: 'Kanagawa',
        },
        {
            name: 'Ōdachō-ōda',
            subdivision: 'Shimane',
        },
        {
            name: 'Ōbu',
            subdivision: 'Aichi',
        },
        {
            name: 'Obita',
            subdivision: 'Nagasaki',
        },
        {
            name: 'Obama',
            subdivision: 'Fukui',
        },
        {
            name: 'Nyūzen',
            subdivision: 'Toyama',
        },
        {
            name: 'Numazu',
            subdivision: 'Shizuoka',
        },
        {
            name: 'Numata',
            subdivision: 'Gunma',
        },
        {
            name: 'Nonoichi',
            subdivision: 'Ishikawa',
        },
        {
            name: 'Nōgata',
            subdivision: 'Fukuoka',
        },
        {
            name: 'Noda',
            subdivision: 'Chiba',
        },
        {
            name: 'Nobeoka',
            subdivision: 'Miyazaki',
        },
        {
            name: 'Nishiwaki',
            subdivision: 'Hyōgo',
        },
        {
            name: 'Nishio',
            subdivision: 'Aichi',
        },
        {
            name: 'Nishinoomote',
            subdivision: 'Kagoshima',
        },
        {
            name: 'Nishinomiya-hama',
            subdivision: 'Hyōgo',
        },
        {
            name: 'Nirasaki',
            subdivision: 'Yamanashi',
        },
        {
            name: 'Ninomiya',
            subdivision: 'Kanagawa',
        },
        {
            name: 'Nikkō',
            subdivision: 'Tochigi',
        },
        {
            name: 'Niitsu-honchō',
            subdivision: 'Niigata',
        },
        {
            name: 'Niimi',
            subdivision: 'Okayama',
        },
        {
            name: 'Niihama',
            subdivision: 'Ehime',
        },
        {
            name: 'Niigata',
            subdivision: 'Niigata',
        },
        {
            name: 'Nichinan',
            subdivision: 'Miyazaki',
        },
        {
            name: 'Naze',
            subdivision: 'Kagoshima',
        },
        {
            name: 'Narutochō-mitsuishi',
            subdivision: 'Tokushima',
        },
        {
            name: 'Nara-shi',
            subdivision: 'Nara',
        },
        {
            name: 'Nanao',
            subdivision: 'Ishikawa',
        },
        {
            name: 'Namerikawa',
            subdivision: 'Toyama',
        },
        {
            name: 'Nakatsugawa',
            subdivision: 'Gifu',
        },
        {
            name: 'Nakatsu',
            subdivision: 'Fukuoka',
        },
        {
            name: 'Nakanojōmachi',
            subdivision: 'Gunma',
        },
        {
            name: 'Nakano',
            subdivision: 'Nagano',
        },
        {
            name: 'Nakamura',
            subdivision: 'Kochi',
        },
        {
            name: 'Nakama',
            subdivision: 'Fukuoka',
        },
        {
            name: 'Naha',
            subdivision: 'Okinawa',
        },
        {
            name: 'Nagoya',
            subdivision: 'Aichi',
        },
        {
            name: 'Nago',
            subdivision: 'Okinawa',
        },
        {
            name: 'Nagasaki',
            subdivision: 'Nagasaki',
        },
        {
            name: 'Nagareyama',
            subdivision: 'Chiba',
        },
        {
            name: 'Nagaoka',
            subdivision: 'Niigata',
        },
        {
            name: 'Nagano',
            subdivision: 'Nagano',
        },
        {
            name: 'Nagahama',
            subdivision: 'Shiga Prefecture',
        },
        {
            name: 'Nabari',
            subdivision: 'Mie',
        },
        {
            name: 'Musashino',
            subdivision: 'Tokyo',
        },
        {
            name: 'Muroto-misakicho',
            subdivision: 'Kochi',
        },
        {
            name: 'Muramatsu',
            subdivision: 'Niigata',
        },
        {
            name: 'Murakami',
            subdivision: 'Niigata',
        },
        {
            name: 'Mukō',
            subdivision: 'Kyoto',
        },
        {
            name: 'Muikamachi',
            subdivision: 'Niigata',
        },
        {
            name: 'Morohongō',
            subdivision: 'Saitama',
        },
        {
            name: 'Moriyama',
            subdivision: 'Shiga Prefecture',
        },
        {
            name: 'Moriguchi',
            subdivision: 'Ōsaka',
        },
        {
            name: 'Mori',
            subdivision: 'Shizuoka',
        },
        {
            name: 'Mizunami',
            subdivision: 'Gifu',
        },
        {
            name: 'Miyoshi',
            subdivision: 'Hiroshima',
        },
        {
            name: 'Miyazu',
            subdivision: 'Kyoto',
        },
        {
            name: 'Miyazaki',
            subdivision: 'Miyazaki',
        },
        {
            name: 'Miyakonojō',
            subdivision: 'Miyazaki',
        },
        {
            name: 'Miyata',
            subdivision: 'Fukuoka',
        },
        {
            name: 'Mitsuke',
            subdivision: 'Niigata',
        },
        {
            name: 'Mitsukaidō',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Mitake',
            subdivision: 'Gifu',
        },
        {
            name: 'Mitaka-shi',
            subdivision: 'Tokyo',
        },
        {
            name: 'Mishima',
            subdivision: 'Shizuoka',
        },
        {
            name: 'Mino',
            subdivision: 'Ōsaka',
        },
        {
            name: 'Mino',
            subdivision: 'Gifu',
        },
        {
            name: 'Minamirinkan',
            subdivision: 'Kanagawa',
        },
        {
            name: 'Minamata',
            subdivision: 'Kumamoto',
        },
        {
            name: 'Minakuchichō-matoba',
            subdivision: 'Shiga Prefecture',
        },
        {
            name: 'Mikuni',
            subdivision: 'Fukui',
        },
        {
            name: 'Miki',
            subdivision: 'Hyōgo',
        },
        {
            name: 'Mihara',
            subdivision: 'Hiroshima',
        },
        {
            name: 'Mibu',
            subdivision: 'Tochigi',
        },
        {
            name: 'Menuma',
            subdivision: 'Saitama',
        },
        {
            name: 'Matsutō',
            subdivision: 'Ishikawa',
        },
        {
            name: 'Matsumoto',
            subdivision: 'Nagano',
        },
        {
            name: 'Matsue',
            subdivision: 'Shimane',
        },
        {
            name: 'Matsudo',
            subdivision: 'Chiba',
        },
        {
            name: 'Matsubase',
            subdivision: 'Kumamoto',
        },
        {
            name: 'Matsubara',
            subdivision: 'Ōsaka',
        },
        {
            name: 'Masuda',
            subdivision: 'Shimane',
        },
        {
            name: 'Maruoka',
            subdivision: 'Fukui',
        },
        {
            name: 'Kamimaruko',
            subdivision: 'Nagano',
        },
        {
            name: 'Marugame',
            subdivision: 'Kagawa',
        },
        {
            name: 'Makurazaki',
            subdivision: 'Kagoshima',
        },
        {
            name: 'Maki',
            subdivision: 'Niigata',
        },
        {
            name: 'Maizuru',
            subdivision: 'Kyoto',
        },
        {
            name: 'Maebashi',
            subdivision: 'Gunma',
        },
        {
            name: 'Maebaru-chūō',
            subdivision: 'Fukuoka',
        },
        {
            name: 'Machida',
            subdivision: 'Tokyo',
        },
        {
            name: 'Kyoto',
            subdivision: 'Kyoto',
        },
        {
            name: 'Kushikino',
            subdivision: 'Kagoshima',
        },
        {
            name: 'Kusatsu',
            subdivision: 'Shiga Prefecture',
        },
        {
            name: 'Kurume',
            subdivision: 'Fukuoka',
        },
        {
            name: 'Kuroda',
            subdivision: 'Aichi',
        },
        {
            name: 'Kurihashi',
            subdivision: 'Saitama',
        },
        {
            name: 'Kure',
            subdivision: 'Hiroshima',
        },
        {
            name: 'Kurayoshi',
            subdivision: 'Tottori',
        },
        {
            name: 'Kurashiki',
            subdivision: 'Okayama',
        },
        {
            name: 'Kumamoto',
            subdivision: 'Kumamoto',
        },
        {
            name: 'Kumagaya',
            subdivision: 'Saitama',
        },
        {
            name: 'Kukichūō',
            subdivision: 'Saitama',
        },
        {
            name: 'Kudamatsu',
            subdivision: 'Yamaguchi',
        },
        {
            name: 'Kozakai-chō',
            subdivision: 'Aichi',
        },
        {
            name: 'Koshigaya',
            subdivision: 'Saitama',
        },
        {
            name: 'Kosai-shi',
            subdivision: 'Shizuoka',
        },
        {
            name: 'Kōnosu',
            subdivision: 'Saitama',
        },
        {
            name: 'Kōnan',
            subdivision: 'Aichi',
        },
        {
            name: 'Komoro',
            subdivision: 'Nagano',
        },
        {
            name: 'Komono',
            subdivision: 'Mie',
        },
        {
            name: 'Komatsushimachō',
            subdivision: 'Tokushima',
        },
        {
            name: 'Komatsu',
            subdivision: 'Ishikawa',
        },
        {
            name: 'Komaki',
            subdivision: 'Aichi',
        },
        {
            name: 'Kokubunji',
            subdivision: 'Tokyo',
        },
        {
            name: 'Kokubu-matsuki',
            subdivision: 'Kagoshima',
        },
        {
            name: 'Koga',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Koga',
            subdivision: 'Fukuoka',
        },
        {
            name: 'Kōfu',
            subdivision: 'Yamanashi',
        },
        {
            name: 'Kodamachō-kodamaminami',
            subdivision: 'Saitama',
        },
        {
            name: 'Kochi',
            subdivision: 'Kochi',
        },
        {
            name: 'Kobe',
            subdivision: 'Hyōgo',
        },
        {
            name: 'Kobayashi',
            subdivision: 'Miyazaki',
        },
        {
            name: 'Kitsuki',
            subdivision: 'Oita',
        },
        {
            name: 'Kitakyushu',
            subdivision: 'Fukuoka',
        },
        {
            name: 'Kitakata',
            subdivision: 'Fukushima',
        },
        {
            name: 'Kitahama',
            subdivision: 'Shiga Prefecture',
        },
        {
            name: 'Kishiwada',
            subdivision: 'Ōsaka',
        },
        {
            name: 'Kisarazu',
            subdivision: 'Chiba',
        },
        {
            name: 'Kisai',
            subdivision: 'Saitama',
        },
        {
            name: 'Kiryū',
            subdivision: 'Gunma',
        },
        {
            name: 'Kikuchi',
            subdivision: 'Kumamoto',
        },
        {
            name: 'Kazo',
            subdivision: 'Saitama',
        },
        {
            name: 'Kawasaki',
            subdivision: 'Kanagawa',
        },
        {
            name: 'Kawasaki',
            subdivision: 'Fukuoka',
        },
        {
            name: 'Kawanishi',
            subdivision: 'Hyōgo',
        },
        {
            name: 'Kawaguchi',
            subdivision: 'Saitama',
        },
        {
            name: 'Kawagoe',
            subdivision: 'Saitama',
        },
        {
            name: 'Katsuyama',
            subdivision: 'Fukui',
        },
        {
            name: 'Kasukabe',
            subdivision: 'Saitama',
        },
        {
            name: 'Kasugai',
            subdivision: 'Aichi',
        },
        {
            name: 'Kashiwazaki',
            subdivision: 'Niigata',
        },
        {
            name: 'Kashiwa',
            subdivision: 'Chiba',
        },
        {
            name: 'Kashima',
            subdivision: 'Saga Prefecture',
        },
        {
            name: 'Kashihara-shi',
            subdivision: 'Nara',
        },
        {
            name: 'Kashihara',
            subdivision: 'Ōsaka',
        },
        {
            name: 'Kaseda-shirakame',
            subdivision: 'Kagoshima',
        },
        {
            name: 'Kasaoka',
            subdivision: 'Okayama',
        },
        {
            name: 'Kasamatsuchō',
            subdivision: 'Gifu',
        },
        {
            name: 'Kariya',
            subdivision: 'Aichi',
        },
        {
            name: 'Karatsu',
            subdivision: 'Saga Prefecture',
        },
        {
            name: 'Kanzakimachi-kanzaki',
            subdivision: 'Saga Prefecture',
        },
        {
            name: 'Kanuma',
            subdivision: 'Tochigi',
        },
        {
            name: 'Kanoya',
            subdivision: 'Kagoshima',
        },
        {
            name: 'Kan’onjichō',
            subdivision: 'Kagawa',
        },
        {
            name: 'Kannabechō-yahiro',
            subdivision: 'Hiroshima',
        },
        {
            name: 'Kanie',
            subdivision: 'Aichi',
        },
        {
            name: 'Kanekomachi',
            subdivision: 'Gunma',
        },
        {
            name: 'Kanda',
            subdivision: 'Fukuoka',
        },
        {
            name: 'Kanazawa',
            subdivision: 'Ishikawa',
        },
        {
            name: 'Kanaya',
            subdivision: 'Shizuoka',
        },
        {
            name: 'Kamojimachō-jōgejima',
            subdivision: 'Tokushima',
        },
        {
            name: 'Kamogatachō-kamogata',
            subdivision: 'Okayama',
        },
        {
            name: 'Kamo',
            subdivision: 'Niigata',
        },
        {
            name: 'Kamirenjaku',
            subdivision: 'Tokyo',
        },
        {
            name: 'Kaminokawa',
            subdivision: 'Tochigi',
        },
        {
            name: 'Kamiichi',
            subdivision: 'Toyama',
        },
        {
            name: 'Kameyama',
            subdivision: 'Mie',
        },
        {
            name: 'Kameoka',
            subdivision: 'Kyoto',
        },
        {
            name: 'Kameda-honchō',
            subdivision: 'Niigata',
        },
        {
            name: 'Kamakura',
            subdivision: 'Kanagawa',
        },
        {
            name: 'Kakogawachō-honmachi',
            subdivision: 'Hyōgo',
        },
        {
            name: 'Kakegawa',
            subdivision: 'Shizuoka',
        },
        {
            name: 'Kakamigahara',
            subdivision: 'Gifu',
        },
        {
            name: 'Kashima-shi',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Kajiki',
            subdivision: 'Kagoshima',
        },
        {
            name: 'Kaizuka',
            subdivision: 'Ōsaka',
        },
        {
            name: 'Kainan',
            subdivision: 'Wakayama',
        },
        {
            name: 'Kagoshima',
            subdivision: 'Kagoshima',
        },
        {
            name: 'Kadoma',
            subdivision: 'Ōsaka',
        },
        {
            name: 'Izumo',
            subdivision: 'Shimane',
        },
        {
            name: 'Izumiōtsu',
            subdivision: 'Ōsaka',
        },
        {
            name: 'Izumi',
            subdivision: 'Ōsaka',
        },
        {
            name: 'Izumi',
            subdivision: 'Kagoshima',
        },
        {
            name: 'Iwatsuki',
            subdivision: 'Saitama',
        },
        {
            name: 'Iwata',
            subdivision: 'Shizuoka',
        },
        {
            name: 'Iwakura',
            subdivision: 'Aichi',
        },
        {
            name: 'Iwakuni',
            subdivision: 'Yamaguchi',
        },
        {
            name: 'Iwai',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Iwade',
            subdivision: 'Wakayama',
        },
        {
            name: 'Itsukaichi',
            subdivision: 'Tokyo',
        },
        {
            name: 'Itoman',
            subdivision: 'Okinawa',
        },
        {
            name: 'Itoigawa',
            subdivision: 'Niigata',
        },
        {
            name: 'Itō',
            subdivision: 'Shizuoka',
        },
        {
            name: 'Itami',
            subdivision: 'Hyōgo',
        },
        {
            name: 'Ishiki',
            subdivision: 'Aichi',
        },
        {
            name: 'Ishikawa',
            subdivision: 'Okinawa',
        },
        {
            name: 'Ishii',
            subdivision: 'Tokushima',
        },
        {
            name: 'Ishige',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Ishigaki',
            subdivision: 'Okinawa',
        },
        {
            name: 'Isesaki',
            subdivision: 'Gunma',
        },
        {
            name: 'Isehara',
            subdivision: 'Kanagawa',
        },
        {
            name: 'Ise',
            subdivision: 'Mie',
        },
        {
            name: 'Isawa',
            subdivision: 'Yamanashi',
        },
        {
            name: 'Isahaya',
            subdivision: 'Nagasaki',
        },
        {
            name: 'Inuyama',
            subdivision: 'Gifu',
        },
        {
            name: 'Ino',
            subdivision: 'Kochi',
        },
        {
            name: 'Innoshima',
            subdivision: 'Hiroshima',
        },
        {
            name: 'Inazawa',
            subdivision: 'Aichi',
        },
        {
            name: 'Ina',
            subdivision: 'Nagano',
        },
        {
            name: 'Imarichō-kō',
            subdivision: 'Saga Prefecture',
        },
        {
            name: 'Imaichi',
            subdivision: 'Tochigi',
        },
        {
            name: 'Ikoma',
            subdivision: 'Nara',
        },
        {
            name: 'Ikeda',
            subdivision: 'Ōsaka',
        },
        {
            name: 'Ikedachō',
            subdivision: 'Tokushima',
        },
        {
            name: 'Ijūin',
            subdivision: 'Kagoshima',
        },
        {
            name: 'Iizuka',
            subdivision: 'Fukuoka',
        },
        {
            name: 'Iiyama',
            subdivision: 'Nagano',
        },
        {
            name: 'Iida',
            subdivision: 'Nagano',
        },
        {
            name: 'Ichinomiya',
            subdivision: 'Aichi',
        },
        {
            name: 'Ibusuki',
            subdivision: 'Kagoshima',
        },
        {
            name: 'Ibaraki',
            subdivision: 'Ōsaka',
        },
        {
            name: 'Ibara',
            subdivision: 'Okayama',
        },
        {
            name: 'Hotaka',
            subdivision: 'Nagano',
        },
        {
            name: 'Honjō',
            subdivision: 'Saitama',
        },
        {
            name: 'Hondo',
            subdivision: 'Kumamoto',
        },
        {
            name: 'Hōfu',
            subdivision: 'Yamaguchi',
        },
        {
            name: 'Hitoyoshi',
            subdivision: 'Kumamoto',
        },
        {
            name: 'Hita',
            subdivision: 'Oita',
        },
        {
            name: 'Hisai-motomachi',
            subdivision: 'Mie',
        },
        {
            name: 'Hiroshima',
            subdivision: 'Hiroshima',
        },
        {
            name: 'Hiratsuka',
            subdivision: 'Kanagawa',
        },
        {
            name: 'Hiratachō',
            subdivision: 'Shimane',
        },
        {
            name: 'Hirara',
            subdivision: 'Okinawa',
        },
        {
            name: 'Hirakata',
            subdivision: 'Ōsaka',
        },
        {
            name: 'Hirado',
            subdivision: 'Nagasaki',
        },
        {
            name: 'Hino',
            subdivision: 'Tokyo',
        },
        {
            name: 'Hino',
            subdivision: 'Shiga Prefecture',
        },
        {
            name: 'Himimachi',
            subdivision: 'Toyama',
        },
        {
            name: 'Himeji',
            subdivision: 'Hyōgo',
        },
        {
            name: 'Hikone',
            subdivision: 'Shiga Prefecture',
        },
        {
            name: 'Hiji',
            subdivision: 'Oita',
        },
        {
            name: 'Hekinan',
            subdivision: 'Aichi',
        },
        {
            name: 'Hayama',
            subdivision: 'Kanagawa',
        },
        {
            name: 'Hatsukaichi',
            subdivision: 'Hiroshima',
        },
        {
            name: 'Hatogaya-honchō',
            subdivision: 'Saitama',
        },
        {
            name: 'Hashimoto',
            subdivision: 'Wakayama',
        },
        {
            name: 'Hanyū',
            subdivision: 'Saitama',
        },
        {
            name: 'Hannō',
            subdivision: 'Saitama',
        },
        {
            name: 'Handa',
            subdivision: 'Aichi',
        },
        {
            name: 'Hamanoichi',
            subdivision: 'Kagoshima',
        },
        {
            name: 'Hamamatsu',
            subdivision: 'Shizuoka',
        },
        {
            name: 'Hamakita',
            subdivision: 'Shizuoka',
        },
        {
            name: 'Hamada',
            subdivision: 'Shimane',
        },
        {
            name: 'Hakui',
            subdivision: 'Ishikawa',
        },
        {
            name: 'Haibara-akanedai',
            subdivision: 'Nara',
        },
        {
            name: 'Hagi',
            subdivision: 'Yamaguchi',
        },
        {
            name: 'Katsuren-haebaru',
            subdivision: 'Okinawa',
        },
        {
            name: 'Hadano',
            subdivision: 'Kanagawa',
        },
        {
            name: 'Hachiōji',
            subdivision: 'Tokyo',
        },
        {
            name: 'Ōmihachiman',
            subdivision: 'Shiga Prefecture',
        },
        {
            name: 'Gyōda',
            subdivision: 'Saitama',
        },
        {
            name: 'Gushikawa',
            subdivision: 'Okinawa',
        },
        {
            name: 'Gōtsuchō',
            subdivision: 'Shimane',
        },
        {
            name: 'Gotenba',
            subdivision: 'Shizuoka',
        },
        {
            name: 'Gosen',
            subdivision: 'Niigata',
        },
        {
            name: 'Gose',
            subdivision: 'Nara',
        },
        {
            name: 'Gojō',
            subdivision: 'Nara',
        },
        {
            name: 'Gōdo',
            subdivision: 'Gifu',
        },
        {
            name: 'Gobō',
            subdivision: 'Wakayama',
        },
        {
            name: 'Ginowan',
            subdivision: 'Okinawa',
        },
        {
            name: 'Gifu-shi',
            subdivision: 'Gifu',
        },
        {
            name: 'Gamagōri',
            subdivision: 'Aichi',
        },
        {
            name: 'Futtsu',
            subdivision: 'Chiba',
        },
        {
            name: 'Honchō',
            subdivision: 'Chiba',
        },
        {
            name: 'Fukuyama',
            subdivision: 'Hiroshima',
        },
        {
            name: 'Fukuroi',
            subdivision: 'Shizuoka',
        },
        {
            name: 'Fukura',
            subdivision: 'Hyōgo',
        },
        {
            name: 'Fukuoka',
            subdivision: 'Fukuoka',
        },
        {
            name: 'Fukumitsu',
            subdivision: 'Toyama',
        },
        {
            name: 'Nishifukuma',
            subdivision: 'Fukuoka',
        },
        {
            name: 'Fukui-shi',
            subdivision: 'Fukui',
        },
        {
            name: 'Fukuechō',
            subdivision: 'Nagasaki',
        },
        {
            name: 'Fukuchiyama',
            subdivision: 'Kyoto',
        },
        {
            name: 'Fukiage-fujimi',
            subdivision: 'Saitama',
        },
        {
            name: 'Fukayachō',
            subdivision: 'Saitama',
        },
        {
            name: 'Fujisawa',
            subdivision: 'Kanagawa',
        },
        {
            name: 'Fujioka',
            subdivision: 'Tochigi',
        },
        {
            name: 'Fujioka',
            subdivision: 'Gunma',
        },
        {
            name: 'Fujinomiya',
            subdivision: 'Shizuoka',
        },
        {
            name: 'Fujieda',
            subdivision: 'Shizuoka',
        },
        {
            name: 'Fuji',
            subdivision: 'Shizuoka',
        },
        {
            name: 'Fuchūchō',
            subdivision: 'Hiroshima',
        },
        {
            name: 'Enzan',
            subdivision: 'Yamanashi',
        },
        {
            name: 'Daitōchō',
            subdivision: 'Ōsaka',
        },
        {
            name: 'Chōfugaoka',
            subdivision: 'Tokyo',
        },
        {
            name: 'Chiryū',
            subdivision: 'Aichi',
        },
        {
            name: 'Chino',
            subdivision: 'Nagano',
        },
        {
            name: 'Chikushino-shi',
            subdivision: 'Fukuoka',
        },
        {
            name: 'Chigasaki',
            subdivision: 'Kanagawa',
        },
        {
            name: 'Chichibu',
            subdivision: 'Saitama',
        },
        {
            name: 'Chatan',
            subdivision: 'Okinawa',
        },
        {
            name: 'Beppu',
            subdivision: 'Oita',
        },
        {
            name: 'Ayabe',
            subdivision: 'Kyoto',
        },
        {
            name: 'Atami',
            subdivision: 'Shizuoka',
        },
        {
            name: 'Ashiya',
            subdivision: 'Hyōgo',
        },
        {
            name: 'Ashikaga',
            subdivision: 'Tochigi',
        },
        {
            name: 'Arai',
            subdivision: 'Niigata',
        },
        {
            name: 'Annaka',
            subdivision: 'Gunma',
        },
        {
            name: 'Anjō',
            subdivision: 'Aichi',
        },
        {
            name: 'Anan',
            subdivision: 'Tokushima',
        },
        {
            name: 'Amagi',
            subdivision: 'Fukuoka',
        },
        {
            name: 'Amagasaki',
            subdivision: 'Hyōgo',
        },
        {
            name: 'Akune',
            subdivision: 'Kagoshima',
        },
        {
            name: 'Kariya',
            subdivision: 'Hyōgo',
        },
        {
            name: 'Aki',
            subdivision: 'Kochi',
        },
        {
            name: 'Aioi',
            subdivision: 'Hyōgo',
        },
        {
            name: 'Ageoshimo',
            subdivision: 'Saitama',
        },
        {
            name: 'Okinawa',
            subdivision: 'Okinawa',
        },
        {
            name: 'Kushima',
            subdivision: 'Miyazaki',
        },
        {
            name: 'Hikari',
            subdivision: 'Yamaguchi',
        },
        {
            name: 'Nagato',
            subdivision: 'Yamaguchi',
        },
        {
            name: 'Hasuda',
            subdivision: 'Saitama',
        },
        {
            name: 'Kamifukuoka',
            subdivision: 'Saitama',
        },
        {
            name: 'Sayama',
            subdivision: 'Saitama',
        },
        {
            name: 'Fussa',
            subdivision: 'Tokyo',
        },
        {
            name: 'Asaka',
            subdivision: 'Saitama',
        },
        {
            name: 'Wako',
            subdivision: 'Saitama',
        },
        {
            name: 'Shimotoda',
            subdivision: 'Saitama',
        },
        {
            name: 'Kimitsu',
            subdivision: 'Chiba',
        },
        {
            name: 'Miura',
            subdivision: 'Kanagawa',
        },
        {
            name: 'Wakayama',
            subdivision: 'Wakayama',
        },
        {
            name: 'Iyo',
            subdivision: 'Ehime',
        },
        {
            name: 'Uwajima',
            subdivision: 'Ehime',
        },
        {
            name: 'Saijō',
            subdivision: 'Ehime',
        },
        {
            name: 'Ōzu',
            subdivision: 'Ehime',
        },
        {
            name: 'Matsuyama',
            subdivision: 'Ehime',
        },
        {
            name: 'Masaki-chō',
            subdivision: 'Ehime',
        },
        {
            name: 'Kawanoechō',
            subdivision: 'Ehime',
        },
        {
            name: 'Hōjō',
            subdivision: 'Ehime',
        },
        {
            name: 'Yuzawa',
            subdivision: 'Akita',
        },
        {
            name: 'Yotsukaidō',
            subdivision: 'Chiba',
        },
        {
            name: 'Yonezawa',
            subdivision: 'Yamagata',
        },
        {
            name: 'Yokotemachi',
            subdivision: 'Akita',
        },
        {
            name: 'Yōkaichiba',
            subdivision: 'Chiba',
        },
        {
            name: 'Yanagawamachi-saiwaichō',
            subdivision: 'Fukushima',
        },
        {
            name: 'Yamoto',
            subdivision: 'Miyagi',
        },
        {
            name: 'Yamagata',
            subdivision: 'Yamagata',
        },
        {
            name: 'Yamada',
            subdivision: 'Iwate',
        },
        {
            name: 'Yachimata',
            subdivision: 'Chiba',
        },
        {
            name: 'Watari',
            subdivision: 'Miyagi',
        },
        {
            name: 'Wakuya',
            subdivision: 'Miyagi',
        },
        {
            name: 'Ushiku',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Tsukuba',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Toride',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Tōno',
            subdivision: 'Iwate',
        },
        {
            name: 'Tomobe',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Tomiya',
            subdivision: 'Miyagi',
        },
        {
            name: 'Tōgane',
            subdivision: 'Chiba',
        },
        {
            name: 'Tendō',
            subdivision: 'Yamagata',
        },
        {
            name: 'Takahata',
            subdivision: 'Yamagata',
        },
        {
            name: 'Takahagi',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Sukagawa',
            subdivision: 'Fukushima',
        },
        {
            name: 'Shizukuishi',
            subdivision: 'Iwate',
        },
        {
            name: 'Shisui',
            subdivision: 'Chiba',
        },
        {
            name: 'Shiroishi',
            subdivision: 'Miyagi',
        },
        {
            name: 'Shiroi',
            subdivision: 'Chiba',
        },
        {
            name: 'Shiogama',
            subdivision: 'Miyagi',
        },
        {
            name: 'Shinjō',
            subdivision: 'Yamagata',
        },
        {
            name: 'Sendai',
            subdivision: 'Miyagi',
        },
        {
            name: 'Sawara',
            subdivision: 'Chiba',
        },
        {
            name: 'Sakura',
            subdivision: 'Chiba',
        },
        {
            name: 'Sagae',
            subdivision: 'Yamagata',
        },
        {
            name: 'Ryūgasaki',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Rifu',
            subdivision: 'Miyagi',
        },
        {
            name: 'Ōtsuchi',
            subdivision: 'Iwate',
        },
        {
            name: 'Ōtawara',
            subdivision: 'Tochigi',
        },
        {
            name: 'Ōmiya',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Omigawa',
            subdivision: 'Chiba',
        },
        {
            name: 'Ōmagari',
            subdivision: 'Akita',
        },
        {
            name: 'Okunoya',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Ōkawara',
            subdivision: 'Miyagi',
        },
        {
            name: 'Ōhara',
            subdivision: 'Chiba',
        },
        {
            name: 'Ōfunato',
            subdivision: 'Iwate',
        },
        {
            name: 'Obanazawa',
            subdivision: 'Yamagata',
        },
        {
            name: 'Ōarai',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Ōami',
            subdivision: 'Chiba',
        },
        {
            name: 'Nihommatsu',
            subdivision: 'Fukushima',
        },
        {
            name: 'Narutō',
            subdivision: 'Chiba',
        },
        {
            name: 'Narita',
            subdivision: 'Chiba',
        },
        {
            name: 'Namie',
            subdivision: 'Fukushima',
        },
        {
            name: 'Naka',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Nagai',
            subdivision: 'Yamagata',
        },
        {
            name: 'Motomiya',
            subdivision: 'Fukushima',
        },
        {
            name: 'Motegi',
            subdivision: 'Tochigi',
        },
        {
            name: 'Moriya',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Morioka',
            subdivision: 'Iwate',
        },
        {
            name: 'Mooka',
            subdivision: 'Tochigi',
        },
        {
            name: 'Mobara',
            subdivision: 'Chiba',
        },
        {
            name: 'Mizusawa',
            subdivision: 'Iwate',
        },
        {
            name: 'Miyako',
            subdivision: 'Iwate',
        },
        {
            name: 'Mito',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Miharu',
            subdivision: 'Fukushima',
        },
        {
            name: 'Matsushima',
            subdivision: 'Miyagi',
        },
        {
            name: 'Mashiko',
            subdivision: 'Tochigi',
        },
        {
            name: 'Marumori',
            subdivision: 'Miyagi',
        },
        {
            name: 'Makabe',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Kuroiso',
            subdivision: 'Tochigi',
        },
        {
            name: 'Kōriyama',
            subdivision: 'Fukushima',
        },
        {
            name: 'Kogota',
            subdivision: 'Miyagi',
        },
        {
            name: 'Kitakami',
            subdivision: 'Iwate',
        },
        {
            name: 'Kitaibaraki',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Kamogawa',
            subdivision: 'Chiba',
        },
        {
            name: 'Katsuura',
            subdivision: 'Chiba',
        },
        {
            name: 'Katsuta',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Katori-shi',
            subdivision: 'Chiba',
        },
        {
            name: 'Kasama',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Karasuyama',
            subdivision: 'Tochigi',
        },
        {
            name: 'Kaminoyama',
            subdivision: 'Yamagata',
        },
        {
            name: 'Kamaishi',
            subdivision: 'Iwate',
        },
        {
            name: 'Kakuda',
            subdivision: 'Miyagi',
        },
        {
            name: 'Iwase',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Iwanuma',
            subdivision: 'Miyagi',
        },
        {
            name: 'Iwaki',
            subdivision: 'Fukushima',
        },
        {
            name: 'Itako',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Ishioka',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Ishinomaki',
            subdivision: 'Miyagi',
        },
        {
            name: 'Ishikawa',
            subdivision: 'Fukushima',
        },
        {
            name: 'Inawashiro',
            subdivision: 'Fukushima',
        },
        {
            name: 'Ichinoseki',
            subdivision: 'Iwate',
        },
        {
            name: 'Ichihara',
            subdivision: 'Chiba',
        },
        {
            name: 'Hobaramachi',
            subdivision: 'Fukushima',
        },
        {
            name: 'Hitachi',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Higashine',
            subdivision: 'Yamagata',
        },
        {
            name: 'Hasaki',
            subdivision: 'Chiba',
        },
        {
            name: 'Hanamaki',
            subdivision: 'Iwate',
        },
        {
            name: 'Furukawa',
            subdivision: 'Miyagi',
        },
        {
            name: 'Funehikimachi-funehiki',
            subdivision: 'Fukushima',
        },
        {
            name: 'Funaishikawa',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Fukushima',
            subdivision: 'Fukushima',
        },
        {
            name: 'Fujishiro',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Edosaki',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Daigo',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Chiba',
            subdivision: 'Chiba',
        },
        {
            name: 'Asahi',
            subdivision: 'Chiba',
        },
        {
            name: 'Ami',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Akita',
            subdivision: 'Akita',
        },
        {
            name: 'Abiko',
            subdivision: 'Chiba',
        },
        {
            name: 'Akitashi',
            subdivision: 'Akita',
        },
        {
            name: 'Bihoro',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Wakkanai',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Tomakomai',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Tōbetsu',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Mutsu',
            subdivision: 'Aomori',
        },
        {
            name: 'Takikawa',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Takanosu',
            subdivision: 'Akita',
        },
        {
            name: 'Sunagawa',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Shizunai-furukawachō',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Shiraoi',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Shimo-furano',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Shibetsu',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Sapporo',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Rumoi',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Otofuke',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Otaru',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Ōdate',
            subdivision: 'Akita',
        },
        {
            name: 'Obihiro',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Noshiro',
            subdivision: 'Akita',
        },
        {
            name: 'Nemuro',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Nayoro',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Nanae',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Namioka',
            subdivision: 'Aomori',
        },
        {
            name: 'Muroran',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Mombetsu',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Misawa',
            subdivision: 'Aomori',
        },
        {
            name: 'Yoichi',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Makubetsu',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Kushiro',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Kuroishi',
            subdivision: 'Aomori',
        },
        {
            name: 'Shimokizukuri',
            subdivision: 'Aomori',
        },
        {
            name: 'Kitami',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Kamiiso',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Iwanai',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Iwamizawa',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Ishikari',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Ichinohe',
            subdivision: 'Iwate',
        },
        {
            name: 'Kitahiroshima',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Hirosaki',
            subdivision: 'Aomori',
        },
        {
            name: 'Hanawa',
            subdivision: 'Akita',
        },
        {
            name: 'Hakodate',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Hachinohe',
            subdivision: 'Aomori',
        },
        {
            name: 'Fukagawa',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Ebetsu',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Date',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Chitose',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Bibai',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Ashibetsu',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Asahikawa',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Aomorishi',
            subdivision: 'Aomori',
        },
        {
            name: 'Abashiri',
            subdivision: 'Hokkaido',
        },
        {
            name: 'Goshogawara',
            subdivision: 'Aomori',
        },
        {
            name: 'Aso',
            subdivision: 'Kumamoto',
        },
        {
            name: 'Nanto-shi',
            subdivision: 'Toyama',
        },
        {
            name: 'Kawage',
            subdivision: 'Mie',
        },
        {
            name: 'Neyagawa',
            subdivision: 'Ōsaka',
        },
        {
            name: 'Hitachi-Naka',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Inashiki',
            subdivision: 'Ibaraki',
        },
        {
            name: 'Ōnojō',
            subdivision: 'Fukuoka',
        },
        {
            name: 'Minokamo',
            subdivision: 'Gifu',
        },
        {
            name: 'Gujō',
            subdivision: 'Gifu',
        },
        {
            name: 'Jōetsu',
            subdivision: 'Niigata',
        },
        {
            name: 'Saitama',
            subdivision: 'Saitama',
        },
        {
            name: 'Higashimurayama-shi',
            subdivision: 'Tokyo',
        },
        {
            name: 'Fujikawaguchiko',
            subdivision: 'Yamanashi',
        },
        {
            name: 'Dazaifu',
            subdivision: 'Fukuoka',
        },
        {
            name: 'Kamigyō-ku',
            subdivision: 'Kyoto',
        },
        {
            name: 'Buzen',
            subdivision: 'Fukuoka',
        },
        {
            name: 'Sendai',
            subdivision: 'Miyagi',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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